define('models/fundtransfer/banktransfer',['backbone', "models/shared/lookups/systext", "models/shared/bankaccount/bankaccount"
], function (Backbone, SystemText, BankAccount) {
    var banktransfer = Backbone.Model.extend({

        url: function () {
            if (this.instanceURL)
                return this.instanceURL;
            else
                return null;
        },
        initialize: function (options) {
            options = options || {};

            this.instanceURL = options.instanceURL;
            this.BankAccountInfo = options.BA;
            this.ExtProxyNumber = options.PN;
            this.transferType = options.BTT;

        },

        parse: function (data) {
            var response = {};
            if (data != null) {
                response.BankName = data.BN;
                response.BankAccountNumber = data.BAN;
                response.BankRoutingNumber = data.RN;
                response.ExtBankAccountId = data.EFID;
                response.ExtReferenceNumber = data.ERN;
                response.ExtProxyNumber = data.PN;
                response.PurseId = data.PID;
                response.CardBalance = data.CB;
                response.AllowedAmount = data.AAMT;
                response.TransferAmount = data.TAMT;
                response.Memo = data.MEM;
                response.TransferType = data.BTT;
                response.ExtConfirmationNo = data.ECN;
                response.TransferMessage = data.TM;
                response.BankAccountStatus = data.BAS;
                response.MinACHInAmount = data.MACHIA;
                response.MaxACHInAmount = data.MXACHIA;
                response.MinACHOutAmount = data.MACHOA;
                response.MaxACHOutAmount = data.MXACHOA;
                response.ExpediteC2BRequestAllowed = data.EC2B;
                response.ExpediteB2CRequestAllowed = data.EB2C;
                response.RequestType = data.BTRT;
                response.ExpeditedACHFee = data.AEF;
                response.StandardACHFee = data.ASF;
                response.ACHTypesOffered = data.ATO;
                response.ExpeditedACHCutOffTime = data.CTT;
                response.NextBusinessday = data.NBD
            }
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.BN = this.attributes.BankName;
            data.BAN = this.attributes.BankAccountNumber;
            data.RN = this.attributes.BankRoutingNumber;
            data.EFID = this.attributes.ExtBankAccountId;
            data.ERN = this.attributes.ExtReferenceNumber;
            data.PN = this.attributes.ExtProxyNumber;
            data.PID = this.attributes.PurseId;
            data.CB = this.attributes.CardBalance;
            data.AAMT = this.attributes.AllowedAmount;
            data.TAMT = this.attributes.TransferAmount;
            data.MEM = this.attributes.Memo;
            data.BTT = this.attributes.TransferType;
            data.TM = this.attributes.TransferMessage;
            data.ECN = this.attributes.ExtConfirmationNo;
            data.BAS = this.attributes.BankAccountStatus;
            data.MACHIA = this.attributes.MinACHInAmount;
            data.MACHOA = this.attributes.MinACHOutAmount;
            data.MXACHOA = this.attributes.MaxACHOutAmount;
            data.BTRT = this.attributes.RequestType;
            data.EC2B = this.attributes.ExpediteC2BRequestAllowed;
            data.EB2C = this.attributes.ExpediteB2CRequestAllowed;
            data.AEF = this.attributes.ExpeditedACHFee;
            data.ASF = this.attributes.StandardACHFee;
            data.ATO = this.attributes.ACHTypesOffered;
            data.CTT = this.attributes.ExpeditedACHCutOffTime;
            data.NBD = this.attributes.NextBusinessday;
            data.MXACHIA = this.attributes.MaxACHInAmount;
            this.attributes = data;
            return Backbone.Model.prototype.save.call(this, attributes, options);
        },
        isNumeric: function (obj) {
            return !jQuery.isArray(obj) && (obj - parseFloat(obj) + 1) >= 0;
        },
        validation: {
            TransferAmount: function (value) {
                if (!isNumeric(value)) {
                    return sysText['FV']['invalid']['amount'];
                }
            },
            Memo: {
                required: false
            }
        }
    });

    return banktransfer;
});
